// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__OMyuM","frameSquare":"recentes_frameSquare__TpN3w","imagem":"recentes_imagem__uN0c-","marca":"recentes_marca__CahEN","modelo":"recentes_modelo__Vi3BS"};